<template>
  <div
    @click="selectItem"
    class="selectableItem"
    :class="{ selectedToolItem: isSelected }"
  >
    <component
      :is="isSelected ? filledIcon : icon"
      class="toolsSVG"
      :class="{ filled: isSelected }"
    />

    <span class="svgTextToolbar">{{ label }}</span>

    <instructions-tooltip
      v-if="instructions && isSelected"
      :icon="filledIcon"
      :instructions="instructions"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import InstructionsTooltip from "@/components/Home/Toolbars/CreateObjects/InstructionsTooltip";

export default {
  name: "CreateObjectsToolbarStandardItem",
  components: { InstructionsTooltip },
  props: {
    layer: {
      type: String,
      required: true
    },

    label: {
      type: String,
      required: true
    },

    icon: {
      required: true
    },

    filledIcon: {
      required: true
    },

    instructions: {
      type: String
    }
  },

  computed: {
    selectedObjectLayer() {
      return this.$store.getters.tools_selectedObjectLayer;
    },

    isSelected() {
      return this.selectedObjectLayer === this.layer;
    }
  },

  methods: {
    ...mapActions(["SET_TOOL_OBJECT_LAYER", "SET_TOOL_TECHNICAL_TYPE"]),

    selectItem() {
      let previousLayer = this.selectedObjectLayer;
      this.$emit("reset-selected-item");

      if (previousLayer !== this.layer) {
        this.SET_TOOL_OBJECT_LAYER(this.layer);
        this.SET_TOOL_TECHNICAL_TYPE(null);

        this.$emit("select-item");
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Toolbars/CreateObjects/ItemStandard.vue